module.exports = __webpack_public_path__ + "static/media/app-img.2ca47a63.png";